<template>
  <i v-bem="{ [name]: true }"></i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

.icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: utils.f-rem-calc(20);
  height: utils.f-rem-calc(20);

  &::before {
    background-color: currentColor;
    transition: all 320ms;
  }
}
</style>
